import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-chocolate-dark text-nude-light pt-20 pb-10" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-51">
          {/* Brand Column */}
          <div data-id="element-52">
            <Link to="/" className="flex items-center gap-2 mb-6" aria-label="Crownehealth Home" data-id="element-53">
              <div className="w-8 h-8 rounded-full bg-gold flex items-center justify-center text-chocolate font-serif font-bold text-xl" data-id="element-54">
                C
              </div>
              <span className="font-serif font-bold text-2xl text-cream tracking-tight" data-id="element-55">
                Crownehealth
              </span>
            </Link>
            <p className="text-nude-dark leading-relaxed mb-6" data-id="element-56">
              Providing premium, compassionate, and personalized healthcare
              services designed around you and your loved ones.
            </p>
            <div className="flex gap-4" data-id="element-57">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-nude hover:bg-gold hover:text-chocolate transition-colors" aria-label="Facebook" data-id="element-58">
                <Facebook size={18} data-id="element-59" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-nude hover:bg-gold hover:text-chocolate transition-colors" aria-label="Twitter" data-id="element-60">
                <Twitter size={18} data-id="element-61" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-nude hover:bg-gold hover:text-chocolate transition-colors" aria-label="Instagram" data-id="element-62">
                <Instagram size={18} data-id="element-63" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-nude hover:bg-gold hover:text-chocolate transition-colors" aria-label="LinkedIn" data-id="element-64">
                <Linkedin size={18} data-id="element-65" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-66">
            <h4 className="text-lg font-serif font-bold text-cream mb-6" data-id="element-67">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-68">
              <li data-id="element-69">
                <Link to="/" className="text-nude-dark hover:text-gold transition-colors" data-id="element-70">
                  Home
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/about" className="text-nude-dark hover:text-gold transition-colors" data-id="element-72">
                  About Us
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/testimonials" className="text-nude-dark hover:text-gold transition-colors" data-id="element-74">
                  Testimonials
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/contact" className="text-nude-dark hover:text-gold transition-colors" data-id="element-76">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-77">
            <h4 className="text-lg font-serif font-bold text-cream mb-6" data-id="element-78">
              Our Services
            </h4>
            <ul className="space-y-4" data-id="element-79">
              <li data-id="element-80">
                <Link to="/services" className="text-nude-dark hover:text-gold transition-colors" data-id="element-81">
                  Medical Care
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/services" className="text-nude-dark hover:text-gold transition-colors" data-id="element-83">
                  Home Care
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/services" className="text-nude-dark hover:text-gold transition-colors" data-id="element-85">
                  Therapy & Rehab
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/services" className="text-nude-dark hover:text-gold transition-colors" data-id="element-87">
                  Wellness Programs
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/services" className="text-nude-dark hover:text-gold transition-colors" data-id="element-89">
                  Specialized Care
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div id="contact" data-id="element-90">
            <h4 className="text-lg font-serif font-bold text-cream mb-6" data-id="element-91">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-92">
              <li className="flex items-start gap-3 text-nude-dark" data-id="element-93">
                <MapPin size={20} className="text-gold shrink-0 mt-1" data-id="element-94" />
                <span data-id="element-95">
                  123 Wellness Way, Suite 100
                  <br data-id="element-96" />
                  Healthcare City, HC 90210
                </span>
              </li>
              <li className="flex items-center gap-3 text-nude-dark" data-id="element-97">
                <Phone size={20} className="text-gold shrink-0" data-id="element-98" />
                <a href="tel:+15551234567" className="hover:text-gold transition-colors" data-id="element-99">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex items-center gap-3 text-nude-dark" data-id="element-100">
                <Mail size={20} className="text-gold shrink-0" data-id="element-101" />
                <a href="mailto:hello@crownehealth.com" className="hover:text-gold transition-colors" data-id="element-102">
                  hello@crownehealth.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-103">
          <p className="text-nude-dark text-sm text-center md:text-left" data-id="element-104">
            &copy; {currentYear} Crownehealth. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm" data-id="element-105">
            <a href="#" className="text-nude-dark hover:text-gold transition-colors" data-id="element-106">
              Privacy Policy
            </a>
            <a href="#" className="text-nude-dark hover:text-gold transition-colors" data-id="element-107">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}